export enum EventPhase {
  Test = 1,
  Grading = 2,
  Interview = 3,
  Closed = 4,
}
